import { render } from "./CriarFase.vue?vue&type=template&id=fd8e497a&scoped=true"
import script from "./CriarFase.vue?vue&type=script&lang=js"
export * from "./CriarFase.vue?vue&type=script&lang=js"

import "./CriarFase.vue?vue&type=style&index=0&id=fd8e497a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd8e497a"]])

export default __exports__